import getWindow from 'Utils/get-window';

const getGtag = () => getWindow()?.gtag;

export const trackNewsletterSubscribe = () =>
  getGtag()?.('event', 'conversion', {
    send_to: 'AW-959332650/hgrfCNGesIkDEKqCuckD',
  });
